export class Score {
    id: string;
    userCode?: string;
    points: number;
    description: string;
    scoreDate?: Date;
    expirationDate?: Date;
    deleted?: boolean;
    expired?: boolean;


    constructor(id: string, points: number) {
        this.id = id;
        this.points = points;
        this.description = '';
    }
}
